/*
 * Project: bellcloud
 * File: apps/frontend/src/features/guide/useGuide.ts
 * Description: 가이드 컨텍스트 정의 및 접근 훅
 */

import { createContext, useContext } from 'react';
import type { GuideContextValue } from './types';

export const GuideContext = createContext<GuideContextValue | null>(null);

/** GuideProvider 하위에서 가이드 제어 API 에 접근한다. */
export function useGuide(): GuideContextValue {
  const context = useContext(GuideContext);
  if (!context) {
    throw new Error('useGuide must be used within a GuideProvider');
  }
  return context;
}
